import {combineReducers} from 'redux';
import article from './articleReducer';
import articles from './articlesReducer';
import articleTemplates from './articleTemplateListReducer';
import articleCategories from './articleCategoryListReducer';
import user from './userReducer';
import someUser from './someUserReducer';
import users from './usersReducer';
import courses from './coursesReducer';
import course from './courseReducer';
import regions from './regionReducer';
import contactPersons from './contactPersonListReducer';
import currencies from './currencyReducer';
import priceTypes from './priceTypeReducer';
import courseCategories from './courseCategoryReducer';
import courseTypes from './courseTypesReducer';
import contactPerson from './contactPersonReducer';
import contactPersonModal from './contactPersonModalReducer';
import showContactPersonDeleteModal from './contactPersonsDeleteModalReducer';
import certificates from './certificatesReducer';
import catalogs from './catalogReducer';
import multistepSelectReducer from './supplierCompetenciesReducer';
import product from './productReducer';
import products from './productsReducer';
import productCategories from './productCategoriesReducer';
import productTypes from './productTypesReducer';
import countries from './countryReducer';
import municipalities from './municipalityReducer';
import addressSearchResults from './addressSearchReducer';
import companyRegions from './company/companyRegionsReducer';
import companyMunicipalities from './company/companyMunicipalitiesReducer';

import companyCategoryRestrictionModal from './company/companyCategoryRestrictionModalReducer';

import userAddressSearchResults from './user/userAddressSearchReducer';
import userProfile from './user/userProfileReducer';
import showPreviewModal from './previewModalReducer';
import analytics from './analytics/analyticsReducer';
import allAnalytics from './analytics/allAnalyticsReducer';
import metrics from './analytics/metricsReducer';
import analyticsDateRange from './analytics/datesReducer';
import analyticsTotal from './analytics/analyticsTotalReducer';
import sortableList from './sortableListReducer';
import changelog from './changelogReducer';
import showTokenValidationModal from './resource/tokenValidationReducer';
import demoAdminUser from './demoAdminReducer';
import maintenanceMode from './maintenanceModeReducer';
import articleCategory from './articleCategoryReducer';
import companyTasks from './company-tasks/companyTasksReducer';
import companyCoverRegions from './company-cover-regions/companyCoverRegionsReducer';

import { reducer as formReducer } from 'redux-form'

// services
import services from './services/servicesReducer';
import service from './services/serviceReducer';
import serviceCategories from './services/serviceCategoriesReducer';

// jobs
import jobs from './job/jobsReducer';
import job from './job/jobReducer';
import showJobDeleteModal from './job/jobsDeleteModalReducer';
import jobRegions from './job/jobRegionReducer';
import jobCategories from './job/jobCategoryReducer';
import jobWorkingTimes from './job/jobWorkingTimeReducer';



// companies
import company from './company/companyProfileReducer';
import companies from './company/companiesReducer';
import companyCategories from './company/companyCategoriesReducer';
import companyPortals from './company/companyPortalsReducer';
import companyKeywordsPacks from './company/companyKeywordsPacksReducer';
import articlesCategories from './company/companyArticlesCategoriesReducer';

// machines
import machine from './machines/machineReducer';
import machines from './machines/machinesReducer';
import machineCategories from './machines/machineCategoriesReducer';

// spinner
import showSpinner from './spinnerReducer';
import buttonsWithSpinner from './buttonSpinnerReducer';
import showSubmitButtonSpinner from './submit/submitButtonReduser';

import showModal from './modalReducer';
import showResetFormModal from './resetFormModalReducer';


//settings
import settings from './settings/settingsReducer';
import setting from './settings/settingReducer';

import sweetAlertModal from './sweetAlertModalReducer';
import templateAlertModal from './templates/templateAlertReducers';


//portal contacts
import portalContactPerson from './portal/portalContactReducer';
import companyPortalContacts from './portal/companyPortalContactReducer';
import portalContacts from './portal/portalContactPersonListReducer';
import departments from './portal/departmentsReducer';
import department from './portal/departmentReducer';
import portals from './portal/portalReducer';

// tips
import tips from './tipsReducer';
import tip from './tipReducer';

// park machine categories
import parkMachineCategories from './park-machine/parkMachineCategoriesReducer';
import parkMachineCategory from './park-machine/parkMachineCategoryReducer';

// park machines
import parkMachine from './park-machine/parkMachineReducer';
import parkMachines from './park-machine/parkMachinesReducer';

// rent machine categories
import rentMachineCategories from './rent-machine/rentMachineCategoriesReducer';
import rentMachineCategory from './rent-machine/rentMachineCategoryReducer';

// vimeo
import vimeo from './vimeoReducer';

// interests
import portalsCategories from './interests/portalsCategoriesReducer';
import interests from './interests/interestsReducer';

// galleries
import gallery from './gallery/galleryReducer';
import galleries from './gallery/galleriesReducer';
import galleryImages from './gallery/galleryImagesReducer';
import galleryImage from './gallery/galleryImageReducer';

// keywords packages
import keywordsPack from './keywords-pack/keywordsPackReducer';
import keywordsPacks from './keywords-pack/keywordsPacksReducer';

// toastr
import {reducer as toastrReducer} from 'react-redux-toastr';

import treeEditorCategories from './categoryTreeEditor/categoryTreeEditorReducer';
import treeEditorCompetencies from './categoryTreeEditor/competencyTreeEditorReducer';
import rentMachine from './machine-rental/rentMachineReducer';
import rentMachines from './rent-machine/rentMachineListReducer';


const rootReducer = combineReducers({
    article,
    articles,
    articleTemplates,
    articleCategories,
    user,
    someUser,
    users,
    course,
    courses,
    regions,
    contactPersons,
    currencies,
    priceTypes,
    courseCategories,
    courseTypes,
    contactPerson,
    showContactPersonModal: contactPersonModal,
    showContactPersonDeleteModal,
    product,
    products,
    productTypes,
    productCategories,
    catalogs,
    jobs,
    job,
    showJobDeleteModal,
    jobRegions,
    jobCategories,
    jobWorkingTimes,
    supplierCompetencies: multistepSelectReducer,
    certificates,
    addressSearchResults,
    company,
    articlesCategories,
    companies,
    companyCategories,
    companyPortals,
    companyKeywordsPacks,
    companyCategoryRestrictionModal,
    countries,
    municipalities,
    showSpinner,
    form: formReducer,
    buttonsWithSpinner,
    services,
    service,
    serviceCategories,
    companyMunicipalities,
    userAddressSearchResults,
    userProfile,
    machines,
    machine,
    machineCategories,
    showSubmitButtonSpinner,
    showPreviewModal,
    showResetFormModal,
    showModal,
    settings,
    portalContactPerson,
    departments,
    portalContacts,
    setting,
    portals,
    companyPortalContacts,
    department,
    analytics,
    allAnalytics,
    metrics,
    sweetAlertModal,
    templateAlertModal,
    analyticsDateRange,
    analyticsTotal,
    tips,
    tip,
    sortableList,
    changelog,
    toastr: toastrReducer,
    showTokenValidationModal,
    vimeo,
    demoAdminUser,
    maintenanceMode,
    treeEditorCategories,
    portalsCategories,
    treeEditorCompetencies,
    interests,
    articleCategory,
    companyTasks,
    companyRegions,
    companyCoverRegions,
    gallery,
    galleries,
    galleryImages,
    parkMachineCategories,
    parkMachineCategory,
    parkMachines,
    parkMachine,
    galleryImage,
    rentMachineCategories,
    rentMachineCategory,
    rentMachine,
    rentMachines,
    keywordsPack,
    keywordsPacks
});


export default rootReducer;


// WEBPACK FOOTER //
// ./web/src/reducers/index.js